export const ADD_MULTIPLE = 'entities/budgetAllocation/ADD_MULTIPLE';
export const ADD = 'entities/budgetAllocation/ADD';
export const UPDATE = 'entities/budgetAllocation/UPDATE';
export const REMOVE = 'entities/budgetAllocation/REMOVE';

export const VOLUNTEER_REWARD_TYPE_NAME = 'Volunteer Grants';
export const VOLUNTEER_REWARD_BUDGET_ALLOCATION = 'VolunteerRewardBudgetAllocation';
export const VOLUNTEER_REWARD_URL_PATH = 'volunteer-matching-grants';
export const CORPORATE_DONATION_URL_PATH = 'corporate-donation-allocation';
